<template>
    <div class="cloud-box">
        <div v-if="!iframeReady" class="loading-container">
            <div class="loading-spinner"></div>
            <div class="loading-text">Loading verification...</div>
        </div>
        <iframe 
            v-show="iframeReady"
            ref="cloudflareIframe"
            :src="iframeUrl"
            frameborder="0"
            width="100%"
            height="120"
            style="border: none;"
            allow="autoplay; fullscreen; cross-origin-isolated"
            sandbox="allow-scripts allow-same-origin allow-forms"
            @load="onIframeLoad"
        ></iframe>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'CloudFlareVerify',
    data() {
        return {
            verifyToken: '',
            iframeUrl: 'https://alleatapp.com/cloudflare-verify.html', // 可以根据需要修改为服务器URL
            iframeReady: false
        }
    },
    mounted() {
        this.setupMessageListener();
    },
    beforeDestroy() {
        // 清理事件监听器
        window.removeEventListener('message', this.handleMessage);
    },
    methods: {
        // 设置消息监听器
        setupMessageListener() {
            window.addEventListener('message', this.handleMessage);
        },
        
        // 处理来自iframe的消息
        handleMessage(event) {
            // 可以根据需要验证来源域名
            // if (event.origin !== 'https://yourdomain.com') return;
            
            const { type, data } = event.data;
            
            switch(type) {
                case 'token-received':
                    console.log('Token received from iframe:', data);
                    this.verifyToken = data;
                    this.$emit('token-received', data);
                    break;
                case 'error':
                    console.error('Error from iframe:', data);
                    this.$message({
                        message: data || 'Verification failed',
                        type: 'error'
                    });
                    break;
                case 'token-response':
                    // 响应获取token的请求
                    if (data) {
                        this.verifyToken = data;
                    }
                    break;
            }
        },
        
        // iframe加载完成
        onIframeLoad() {
            this.iframeReady = true;
            console.log('CloudFlare iframe loaded');
        },
        
        // 重置验证
        reSetTurnSite() {
            this.verifyToken = '';
            if (this.iframeReady && this.$refs.cloudflareIframe) {
                this.$refs.cloudflareIframe.contentWindow.postMessage({
                    type: 'reset'
                }, '*');
            }
        },
        
        // 获取token
        getToken() {
            if (!this.verifyToken) {
                console.log('Please complete the verification');
                // 向iframe请求token
                if (this.iframeReady && this.$refs.cloudflareIframe) {
                    this.$refs.cloudflareIframe.contentWindow.postMessage({
                        type: 'getToken'
                    }, '*');
                }
                return null;
            }
            return this.verifyToken;
        },
        
        // 手动触发验证（如果需要）
        triggerVerification() {
            if (this.iframeReady && this.$refs.cloudflareIframe) {
                this.$refs.cloudflareIframe.contentWindow.postMessage({
                    type: 'init'
                }, '*');
            }
        }
    }
}
</script>

<style lang="scss" >
.cloud-box {
    padding-left: 45px;
    position: relative;
    min-height: 120px;
}

.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 120px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #e9ecef;
}

.loading-spinner {
    width: 24px;
    height: 24px;
    border: 2px solid #f3f3f3;
    border-top: 2px solid #007bff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 8px;
}

.loading-text {
    color: #666;
    font-size: 14px;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

@media screen and (min-width: 950px) {
    .cloud-box{
        padding-left: 156px;
    }
}
</style>